<template>
  <div class="result">
    <div class="fail"></div>
    <div class="message">{{ message }}</div>
    <div>
      <el-button class="button-repay" @click="closePage">重新下单</el-button>
    </div>
  </div>
</template>

<script>
import { getBalance } from '@/api/vcurrency'
import appInfo from '@/assets/js/appInfo'

export default {
  name: 'PayFail',
  props: ['message'],
  data() {
    return {
      balance: 0
    }
  },
  computed: {
    price() {
      return this.$route.query.price
    },
    isCaiBi() {
      return this.payMethod === 3
    }
  },
  created() {
    getBalance().then(balance => (this.balance = balance))
  },
  methods: {
    closePage() {
      const url = appInfo.getParam('callback')
      const name = appInfo.getParam('name')

      window.open(url, name)

      setTimeout(() => window.close(), 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #000000;
}

.fail {
  width: 320px;
  height: 178px;
  background: url('./images/fail.png') no-repeat center;
  background-size: contain;
}

.message {
  font-size: 16px;
  color: #262626;
}

.button-repay {
  width: 120px;
  height: 40px;
  background-color: #e64c2e;
  border-radius: 5px;
  color: #ffffff;
  margin-top: 56px;
}
</style>
